import {ru} from 'vuejs-datepicker/dist/locale'

export default component => {
  return {
    name: 'VsSelect',
    props: typeof component === 'function' ? component.options.props : Object.assign({}, component.props, {
      inBody: {
        type: Boolean,
        default: false
      },
      acceptable: {
        type: Boolean,
        default: false
      }
    }),
    data() {
      return {
        newPropsLocal: {},
        datepicker: {},
        calendars: {
          year: null,
          month: null,
          day: null,
        }
      }
    },
    computed: {
      newProps: {
        get() {
          this.newPropsLocal = Object.assign({}, this.$props);
          this.newPropsLocal.language = ru;
          this.newPropsLocal.inBody = false;
          this.newPropsLocal.acceptable = false;
          return this.newPropsLocal;
        },
        set(value) {
          this.newPropsLocal = value;
        }
      }
    },
    methods: {
      updatePositions() {
        this.$nextTick(() => {
          let topx = 0;
          let leftx = 0;
          let scrollTopx = window.pageYOffset || document.documentElement.scrollTop;
          let scrollLeftx = window.pageXOffset || document.documentElement.scrollLeft;
          let content = this.datepicker.$el;

          this.datepicker.$children.forEach(child => {
            if (child.$el.classList.contains('vdp-datepicker__calendar')) {
              let elx = child.$el;
              elx.style.position = 'fixed';

              if (content.getBoundingClientRect().top + content.scrollHeight + elx.clientHeight + 5 >= window.innerHeight) {
                topx = content.getBoundingClientRect().top - elx.clientHeight;
              } else {
                topx = content.getBoundingClientRect().top + content.scrollHeight;
              }

              if (content.getBoundingClientRect().left + content.scrollWidth + elx.clientWidth + 5 >= window.innerWidth) {
                leftx = content.getBoundingClientRect().left + content.scrollWidth + scrollLeftx - elx.clientWidth
              } else {
                leftx = content.getBoundingClientRect().left + scrollLeftx;
              }

              if (leftx < 5) {
                leftx = 5;
              }

              if (topx < 5) {
                topx = 5;
              }

              elx.style.top = `${topx}px`;
              elx.style.left = `${leftx}px`;
            }
          });
        })
      },
      setCalendars() {
        this.$nextTick(() => {
          let children = this.datepicker.$children.filter(c => c.$el.classList.contains('vdp-datepicker__calendar'));
          this.calendars.month = children.find(c => c.showMonthView !== undefined) || null;
          this.calendars.year = children.find(c => c.showYearView !== undefined) || null;
          this.calendars.day = children.find(c => c.showDayView !== undefined) || null;
          children.forEach(c => c.$el.remove());
        });
      },
      showCalendar(calendar) {
        if (this.inBody && calendar !== null) {
          calendar.$el.style.setProperty('z-index', '999999999', 'important');
          document.body.append(calendar.$el);
        }
      },
      removeCalendar(calendar) {
        if (this.inBody && calendar !== null && document.body.contains(calendar.$el)) {
          document.body.removeChild(calendar.$el);
        }
      },
      getTypedDate(value, format) {
        let typedDate;

        /**
         * Identify the correct separator used when
         * separating day, month, and year.
         *
         * Default: "/"
         */
        let separator = [' ', /\./, ',', '-', '/'].find((val) => {
          let count = (format.match(new RegExp(val, 'g')) || []).length;
          return count > 0
        }, '/');
        let formatParts = format.split(separator);
        let dateParts = value.split(separator);

        /**
         * Get each indexes/sequence for day, month,
         * and year based on the format.
         */
        let indexes = {
          day: formatParts.findIndex((part) => {
            return part.toLowerCase().includes('d')
          }),
          month: formatParts.findIndex((part) => {
            return part.toLowerCase().includes('m')
          }),
          year: formatParts.findIndex((part) => {
            return part.toLowerCase().includes('y')
          })
        };

        /**
         * Get each length of day, month, and year
         */
        let len = {
          day: formatParts[indexes.day],
          month: formatParts[indexes.month],
          year: formatParts[indexes.year]
        };
        /**
         * Get each value of day, month, and year
         */
        let values = {
          day: dateParts[indexes.day],
          month: dateParts[indexes.month],
          year: dateParts[indexes.year]
        };

        /**
         * Default month number format
         */
        let monthNum = values.month - 1;

        /**
         * Only allow if day, month, and year
         * is already been typed.
         */
        if (values.day && values.month && values.year) {
          /**
           * Check the length of each item (day, month, year)
           * if its the same with the passed format.
           */
          if (values.day.length === len.day.length && values.month.length === len.month.length && values.year.length === len.year.length) {
            /**
             * We only support until this month format ("MMM").
             * No support yet for month format "MMMM"
             */
            let monthNames = [
              'Jan', 'Feb', 'Mar',
              'Apr', 'May', 'Jun',
              'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'
            ]
            /**
             * Check once month value is 3 characters in length
             */
            if (values.month.length === 3) {
              monthNum = monthNames.findIndex((name) => {
                return name === values.month
              })
            }
            /**
             * Get the unix timestamp of typed date.
             */
            typedDate = new Date(values.year, monthNum, values.day).valueOf()
          }
        } else if (values.month && values.year) {
          /**
           * Check the length of each item (day, month, year)
           * if its the same with the passed format.
           */
          if (values.month.length === len.month.length && values.year.length === len.year.length) {
            /**
             * We only support until this month format ("MMM").
             * No support yet for month format "MMMM"
             */
            let monthNames = [
              'Jan', 'Feb', 'Mar',
              'Apr', 'May', 'Jun',
              'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'
            ]
            /**
             * Check once month value is 3 characters in length
             */
            if (values.month.length === 3) {
              monthNum = monthNames.findIndex((name) => {
                return name === values.month
              })
            }
            /**
             * Get the unix timestamp of typed date.
             */
            typedDate = new Date(values.year, monthNum, 1).valueOf();
          }
        }

        return typedDate;
      },
      focus(){
        this.datepicker.showCalendar();
      },
      close(){
        for (let calendar in this.calendars){
          this.removeCalendar(this.calendars[calendar]);
        }
      }
    },
    mounted() {
      this.datepicker = this.$children[0];
      if (this.inBody) {
        this.setCalendars();
      }

      if (this.datepicker.typeable) {
        let datePickerInput = this.datepicker.$children[0];

        let formatValue = (format, value, translation) => {
          return typeof format === 'function'
              ? format(value)
              : datePickerInput.utils.formatDate(new Date(value), format, translation)
        };
        // this.datepicker.addEventListener('input');
        datePickerInput.input.addEventListener('keydown', (event) => {
          if (event.keyCode === 13) {
            event.preventDefault();
            let typedDate = this.getTypedDate(datePickerInput.input.value, datePickerInput.format)
            if (!isNaN(typedDate) && typedDate !== undefined) {
              datePickerInput.typedDate = formatValue(datePickerInput.format, typedDate, datePickerInput.translation);
              datePickerInput.$emit('typedDate', new Date(typedDate));
            } else {
              datePickerInput.typedDate = false;
              this.$emit('selected', null);
              this.$emit('input', null);
            }

          }
        });

        datePickerInput.parseTypedDate = (event) => {
          let input = datePickerInput.input;

          // close calendar if escape or enter are pressed
          let buttons = [27] //escape];
          if (buttons.includes(event.keyCode)) {
            input.blur();
          }

          let typedDate = this.getTypedDate(datePickerInput.input.value, datePickerInput.format)

          let isArrowsDown = [37, 39].includes(event.keyCode);
          let isEnterDown = [13].includes(event.keyCode);
          let isAcceptable = this.acceptable;

          if (!isNaN(typedDate) && typedDate !== undefined) {
            datePickerInput.typedDate = input.value;
            if ((!isArrowsDown && !isEnterDown && !isAcceptable) || (!isArrowsDown && isEnterDown && !isAcceptable) || (!isArrowsDown && isEnterDown && isAcceptable)) {
              datePickerInput.$emit('typedDate', new Date(typedDate));
              if (isAcceptable && isEnterDown) {
                this.$emit('enter-press');
              }
            }
          } else if (isEnterDown) {
            datePickerInput.typedDate = false;
            this.$emit('selected', null);
            this.$emit('input', null);
            // datePickerInput.$emit('typedDate', null);
          }
        };

        datePickerInput.inputBlurred = () => {
          if (datePickerInput.typeable && isNaN(Date.parse(datePickerInput.selectedDate))) {
            datePickerInput.clearDate();
            datePickerInput.input.value = null;
            datePickerInput.typedDate = false;
            this.$emit('selected', null);
            this.$emit('input', null);
          }
          datePickerInput.$emit('closeCalendar');
        }
      }

      this.datepicker.setPageDateOld = this.datepicker.setPageDate;
      this.datepicker.setPageDate = (props) => {
        this.datepicker.setPageDateOld(props);
        this.updatePositions();
      }
    },
    watch: {
      'datepicker.showYearView'() {
        if (this.datepicker.showYearView) {
          this.showCalendar(this.calendars.year);
          this.updatePositions();
        } else {
          this.removeCalendar(this.calendars.year);
        }
      },
      'datepicker.showMonthView'() {
        if (this.datepicker.showMonthView) {
          this.showCalendar(this.calendars.month);
          this.updatePositions();
        } else {
          this.removeCalendar(this.calendars.month);
        }
      },
      'datepicker.showDayView'() {
        if (this.datepicker.showDayView) {
          this.showCalendar(this.calendars.day);
          this.updatePositions();
        } else {
          this.removeCalendar(this.calendars.day);
        }
      }
    },
    render(h) {
      const slots = Object.keys(this.$slots).reduce((arr, key) => arr.concat(this.$slots[key]), []);
      return h(component, {
        attrs: this.$attrs,
        props: this.newProps,
        on: this.$listeners,
      }, slots);
    }
  }
};
